module.exports = __webpack_public_path__ + "img/svg/pro.5b5869f1f86c7de70319703c514c33fa.svg";